<template>
  <section class="interest-point">
    <div class="nav-top">
      <router-link to="/admin/interestPoints" class="arrow-back">
        <img src="@/assets/arrow-orange.svg">
        <p>Voltar</p>
      </router-link>
      <elvas-button :button="{title: 'publicar'}" @click.native="saveInterestPoint()"></elvas-button>
    </div>
    <notification-bar :notification="notification" @close="notification = null"></notification-bar>
    <div v-if="interestPoint">
      <h4 class="admin-medium-bold-text">Ponto de Interesse</h4>
      <p class="id">ID: {{id}}</p>
      <h5 class="admin-small-bold-text-brown">Images</h5>
      <div v-if="$route.params.id !== 'new'">
        <p class="admin-small-text-brown">Adicionar até 3 imagens</p>
        <section class="interest-point-images">
          <div class="image" v-for="(image, key) in interestPoint.images" :key="image" >
            <label :for="'image-' + key">
              <img :src="image.image_url">
            </label>
            <input type="file" :id="'image-' + key" hidden @change="e => uploadImage(e, image.description)">
          </div>
        </section>
      </div>
      <div v-else>
        <p class="admin-small-text-brown">Imagens apenas podem ser adicionadas depois de criado o ponto de interesse.</p>
      </div>
      <section class="data">
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Nome</p>
            <div><input placeholder="Nome em Português (PT)" v-model="
              translations.find(t => t.language === 'pt').title
            "></div>
            <div class="div-input-margin"><input placeholder="Nome em Inglês (EN)" v-model="
              translations.find(t => t.language === 'en').title
            "></div>
            <div class="div-input-margin"><input placeholder="Nome em Espanhol (ES)" v-model="
              translations.find(t => t.language === 'es').title
            "></div>
          </div>
          <div>
            <p class="admin-small-bold-text-brown">Tipologia</p>
            <select v-model="interestPoint.type">
              <option value="" disabled selected>Tipologia</option>
              <option value="onde_dormir">Onde Dormir</option>
              <option value="o_que_visitar">O que Visitar</option>
              <option value="onde_comer">Onde Comer</option>
              <option value="onde_comprar">Onde Comprar</option>
            </select>
            <input placeholder="Subtipo" v-model="interestPoint.subtype">
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Descrição</p>
            <div><textarea placeholder="Descrição em Português (PT)" v-model="translations.find(t => t.language === 'pt').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Inglês (EN)" v-model="translations.find(t => t.language === 'en').description"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Descrição em Espanhol (ES)" v-model="translations.find(t => t.language === 'es').description"></textarea></div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Latitude</p>
            <div><input placeholder="Latitude" v-model="interestPoint.lat" disabled></div>
          </div>
          <div>
            <p class="admin-small-bold-text-brown">Longitude</p>
            <div><input placeholder="Longitude" v-model="interestPoint.lng" disabled></div>
          </div>
        </section>
        <section>
          <section id="map"></section>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Morada</p>
            <div><input placeholder="Morada" v-model="interestPoint.address"></div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Telefone</p>
            <div><input placeholder="Telefone" v-model="interestPoint.phone_number"></div>
          </div>
          <div>
            <p class="admin-small-bold-text-brown">Website</p>
            <div><input placeholder="Website" v-model="interestPoint.website"></div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Horário de Verão</p>
            <div><textarea placeholder="Ex. Abril a setembro
  Terça-feira, das 14h às 18h
  De quarta-feira a domingo, das 11h às 18h" v-model="translations.find(t => t.language === 'pt').summer_schedule"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Ex. April to September
Tuesday, from 14h to 18h
From Wednesday to Sunday, from 11h to 18h" v-model="translations.find(t => t.language === 'en').summer_schedule"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Ex. Abril a Septiembre
Martes, de 14h a 18h
De Miércoles a Domingo, de 11h a 18h" v-model="translations.find(t => t.language === 'es').summer_schedule"></textarea></div>
          </div>
          <div>
            <p class="admin-small-bold-text-brown">Horário de Inverno</p>
            <div><textarea placeholder="Ex. Outubro a Março
Terça-feira, das 13h às 17h
De quarta-feira a domingo, das 10h às 17h" v-model="translations.find(t => t.language === 'pt').winter_schedule"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Ex. October to March
Tuesday, from 13h to 17h
From Wednesday to Sunday, from 10h to 17h" v-model="translations.find(t => t.language === 'en').winter_schedule"></textarea></div>
            <div class="div-input-margin"><textarea placeholder="Ex. de Octubre a Marzo
Martes de 13h a 17h
De Miércoles a Domingo, de 10h a 17h" v-model="translations.find(t => t.language === 'es').winter_schedule"></textarea></div>
          </div>
        </section>
        <section>
          <div>
            <p class="admin-small-bold-text-brown">Horário de Verão</p>
            <div class="div-input-margin"><input placeholder="Ex. *Encerra segunda-feira todo o dia e terça-feira no período da manhã." v-model="translations.find(t => t.language === 'pt').schedule_extra"></div>
            <div class="div-input-margin"><input placeholder="Ex. *Closed all-day on Monday and Tuesday morning." v-model="translations.find(t => t.language === 'en').schedule_extra"></div>
            <div class="div-input-margin"><input placeholder="Ex. *Cerrado los lunes todo el día y martes por la mañana." v-model="translations.find(t => t.language === 'es').schedule_extra"></div>
          </div>
        </section>
      </section>
    </div>
    <elvas-button class="delete-button" v-if="interestPoint && $route.params.id !== 'new'" :button="{title: 'eliminar'}" @click.native="deleteInterestPoint()"></elvas-button>
  </section>
</template>
<script>
import NotificationBar from '../../components/notification-bar.vue'

let image = require('@/assets/interest_point_marker_clicked_2.png')
export default {
  name: 'adminInterestPoint',
  components: {
    NotificationBar
  },
  props: ['id'],
  data() {
    return {
      interestPoint: null,
      translations: [
        {
          language: 'pt'
        },
        {
          language: 'en'
        },
        {
          language: 'es'
        }
      ],
      notification: null
    }
  },
  async mounted () {
    if (this.$route.params.id !== 'new') {
      this.interestPoint = await this.api.get('interestPoint/' + this.id)
      this.translations.forEach(t => {
        let interestPointTranslation = this.interestPoint.translations.find(it => it.language === t.language)
        if (interestPointTranslation) {
          t.title = interestPointTranslation.title
          t.description = interestPointTranslation.description
          t.summer_schedule = interestPointTranslation.summer_schedule
          t.winder_schedule = interestPointTranslation.winder_schedule
          t.schedule_extra = interestPointTranslation.schedule_extra
          t.exists = true
        }
      })
    } else {
      this.interestPoint = {}
    }
    setTimeout(() => {
      this.loadMap()
    }, 400)
    
  },
  methods: {
    async loadMap () {
      try {
        var uluru = {lat: Number(38.8802201), lng: Number(-7.1627818)};
        let map = new google.maps.Map(document.getElementById('map'), {
          zoom: 16,
          center: uluru,
          mapTypeId: 'satellite',
          scrollwheel: false,
          draggable: false
        })
        map.addListener("click", (event) => {
          if (this.marker) this.marker.setMap(null)
          this.interestPoint.lat = event.latLng.lat()
          this.interestPoint.lng = event.latLng.lng()
          this.marker = new google.maps.Marker({
            position: {lat: event.latLng.lat(), lng: event.latLng.lng()},
            icon: image,
            map
          });
        })
        this.map = map
      } catch (error) {
        console.error(error);
      }
    },
    async saveInterestPoint () {
      let response
      if (this.$route.params.id !== 'new') {
        response = await this.api.put('/interestPoint/' + this.interestPoint.id, this.interestPoint)
      } else {
        response = await this.api.post('/interestPoint', this.interestPoint)
        this.interestPoint = response.data
      }
      this.translations.forEach(t => {
        if (t.exists) {
          this.saveInterestPointTranslation(t)
        } else {
          this.addInterestPointTranslation(t)
        }
      })
      this.notification = 'Ponto de interesse salvo com sucesso'

    },
    async saveInterestPointTranslation (interestPointTranslation) {
      let response = await this.api.put('/interestPointTranslation/' + this.interestPoint.id + '/language/' + interestPointTranslation.language, interestPointTranslation) 

    },
    async addInterestPointTranslation (interestPointTranslation) {
      let response = await this.api.post('/interestPointTranslation', {...interestPointTranslation, interest_point_id: this.interestPoint.id})
      interestPointTranslation.exists = true

    },
    async uploadImage (e, description) {
      let data = new FormData()
      data.append('image', e.target.files[0])
      data.append('content_id', this.interestPoint.id)
      data.append('description', description)

      let response = await this.api.post('/image', data)
      let imageObject = this.interestPoint.images.find(image => image.description === description)
      if (imageObject) {
        let index = this.interestPoint.images.indexOf(imageObject)
        this.interestPoint.images.splice(index, 1, response.data)
      }
    },
    async deleteInterestPoint () {
      await this.api.delete('/interestPoint/' + this.interestPoint.id)
      this.$router.push('..')
    }
  }
}
</script>
<style lang="scss" scoped>
.interest-point {
  width: 100%;
  padding: 16px 128px 100px 128px;
  flex-grow: 1;
  background: #fff;

  @media (max-width: 1000px){
    padding: 16px 56px 100px 56px;
    width: calc(100% - 300px);
  }

  @media (max-width: 550px){
    padding: 16px 12px 100px 12px;
    width: calc(100% - 100px);
  }
}
.notification-bar {
  margin-bottom: 20px;
}
.nav-top {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}
.arrow-back {
  display: flex;
  align-items: center;
  img {
    transform: rotateY(180deg);
  }
  p {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    color: #f6b92f;
    text-transform: uppercase;
  }

  @media (max-width: 550px){
    img {
      width: 16px;
      height: 16px;
    }
  }
}
.elvas-button {
  margin-left: auto;

  @media (max-width: 550px){
    padding: 16px 28px;
  }
}
.interest-point-images {
  display: flex;
  width: 100%;
  margin-top: 16px;
  .image {
    width: calc(100% / 3 - 20px);
    img {
      width: 100%;
      cursor: pointer;
    }
    &:nth-of-type(2) {
      margin: 0 30px;
    }
  }

  @media (max-width: 1000px){
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    .image {
      width: 100%;

      &:nth-of-type(2) {
        margin: 0;
      }
    }
  }

  @media (max-width: 700px){
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    .image {
      width: 100%
    }
  }
}
input, textarea, select {
  padding: 12px 16px;
  border: 1px solid#f6ede0;
  width: calc(100% - 32px);
  &:active, &:focus {
    outline: 1px solid #f6b92f;
  }
}
select {
  margin-top: 16px;
  @media (max-width: 800px){
    width: 100%;
  }
}
textarea {
  min-height: 88px;
}
h4 {
  margin-bottom: 5px;
}
h5 {
  margin-bottom: 10px;
}
.id {
  margin-bottom: 32px;
}
.admin-small-bold-text-brown {
  margin-bottom: 16px;
}
.base-interest-point-information, .translation-interior {
  margin-left: 20px;
  margin-right: 60px;
  & > section {
    display: flex;
    width: 100%;
    & > div {
      margin-right: 40px;
      flex-grow: 1;
      margin-bottom: 10px;
      input, textarea {
        width: 100%;
        padding: 5px;
        margin: 5px 0 20px 0;
      }
      textarea {
        min-height: 60px;
        margin: 25px 0 20px 0;
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
}
.data {
  section {
    width: 100%;
    display: flex;
    margin-top: 32px;
    div {
      flex-grow: 1;
    }
    & > div:nth-of-type(2) {
      padding-left: 30px;
    }
  }

  @media (max-width: 800px){
    section {
      flex-direction: column;

      & > div:nth-of-type(2) {
        padding-left: 0;
        margin-top: 32px;
      }
    }
  }
}
.div-input-margin {
  margin-top: 16px;
}
.translations {
  h5 {
    margin-left: 20px;
  }
  .translation-container, .new-translation-container {
    .language {
      display: flex;
      margin: 10px 0;
      margin-left: 20px;
      .language-name {
        margin-left: 10px;
        font-weight: bold;
      }
      select {
        margin-left: 10px;
      }
    }
  }
  .translation-container {
    margin-left: 20px;
  }
}

#map {
  width: 100%;
  margin: 0 0 0 0;
  height: calc(70vh);
}
</style>